import { UserGroup } from "admin/types/interfaces/user";

export const excludeSystemTags = (tags: UserGroup[]) => {
  return tags.filter(
    (tag) => !tag.is_internal && !tag.name.startsWith("project_") && tag.name !== "user"
  );
};
